import React from 'react'
import PropTypes from 'prop-types'
import TopicList from '../TopicList'
import ArticleList from '../ArticleList'
import { SpacerVertical } from 'mage-deps/@klarna/bubble-ui'
import ResultTitle from './ResultTitle'
import NoResultsMessage from './NoResultsMessage'

ResultsView.propTypes = {
  topics: PropTypes.arrayOf(PropTypes.object).isRequired,
  articles: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default function ResultsView({ topics, articles }) {
  if (topics.length || articles.length) {
    return (
      <>
        <ResultTitle
          length={topics.length}
          singleResultTranslation="hqm.search.results.singleTopicFound"
          multipleResultsTranslation="hqm.search.results.multipleTopicsFound"
        />
        <SpacerVertical small />
        <TopicList topics={topics} analyticsCategory="uhqm/topic-title/search" />

        {!!topics.length && <SpacerVertical medium />}

        <ResultTitle
          length={articles.length}
          singleResultTranslation="hqm.search.results.singleArticleFound"
          multipleResultsTranslation="hqm.search.results.multipleArticlesFound"
        />
        <ArticleList articles={articles} analyticsCategory="uhqm/article-title/search" />
      </>
    )
  } else {
    return <NoResultsMessage />
  }
}
